import { Box, Typography } from '@mui/material';
import { TableLoadingLayout } from 'components/layouts/LoadingLayouts/TableLoadingLayout';
import { GeneralTable } from 'components/shared/Table/GeneralTable';
import { ErrorTypography } from 'components/styled/ErrorTypography';
import { ShipmentsDetailsData } from 'models/Shipments';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ShipmentLabelProductsTableRow } from './ShipmentLabelProductsTableRow';
import { SHIPMENT_LABEL_PRODUCTS_HEAD_CELLS } from 'utils/constans/tableHeads/shipmentsTableHead';

const ShipmentLabelProducts: React.FC<{
    products: ShipmentsDetailsData[];
    isLoading: boolean;
    isError: boolean;
}> = (props) => {
    const { products, isError, isLoading } = props;

    const tableHeadSettings = {
        translateNs: 'shipments',
        translatePrefix: 'SHIPMENT_DETAILS.TABLE_HEAD',
        selectable: false,
        headContent: SHIPMENT_LABEL_PRODUCTS_HEAD_CELLS,
    };

    const filterTerm = (search) => {
        return products.filter((el) => {
            return (
                el.description.includes(search.toLowerCase()) ||
                el.lineObjectNumber.includes(search.toLowerCase())
            );
        });
    };

    const tableToolbarSettings = {
        translateNs: 'shipments',
        translatePrefix: 'SHIPMENT_DETAILS.TABLE_TOOLBAR',
    };

    const setTable = () => {
        switch (true) {
            case isLoading:
                return <TableLoadingLayout />;
            case isError:
                return <ErrorTypography errorCode={'SHIPMENT_DETAILS_ERROR'} />;
            case !isLoading && products.length > 0:
                return (
                    <GeneralTable<ShipmentsDetailsData, ShipmentsDetailsData>
                        fullList={products}
                        rowComponent={ShipmentLabelProductsTableRow}
                        filterTerm={filterTerm}
                        defaultOrderBy={'lineObjectNumber'}
                        selectHandleId={'lineObjectNumber'}
                        tableHeadSettings={tableHeadSettings}
                        tableToolbarSettings={tableToolbarSettings}
                        isLoading={isLoading}
                    />
                );
            default:
                return <ErrorTypography errorCode={'SHIPMENT_DETAILS_ERROR'} />;
        }
    };

    return <Box sx={{ paddingTop: '20px' }}>{setTable()}</Box>;
};

export default ShipmentLabelProducts;
